import * as React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { PermissionEnum } from "../misc/api/ApiPermissionEnum";
import { useHasSomePermissions, useHasSomeGlobalPermissions } from "../misc/components/Authorization";

export interface PrivateRouteProps extends RouteProps<any> {
    permissions: PermissionEnum[] | PermissionEnum;
    children: any;
}

export const PrivateRoute = ({ permissions, children, ...rest }: PrivateRouteProps) => {
    const wrappedPermissions = Array.isArray(permissions) ? permissions : [permissions];
    const valid = useHasSomePermissions(wrappedPermissions);
    return (
        <Route
            {...rest}
            render={({ location }) =>
                valid ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: "/unauthorized",
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    );
}

export const PrivateRouteAllStudies = ({ permissions, children, ...rest }: PrivateRouteProps) => {
    const wrappedPermissions = Array.isArray(permissions) ? permissions : [permissions];
    const valid = useHasSomeGlobalPermissions(wrappedPermissions);
    return (
        <Route
            {...rest}
            render={({ location }) =>
                valid ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: "/unauthorized",
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    );
}
